import React from "react";
import IndexSection from "components/indices/IndexSection";
const IndicesOverview = ({ indexDetails, indices, indexSetId = void 0 }) => {
  const indicesFilteredByTier = (indicesList, tier) => indicesList.filter((index) => index.tier === tier);
  const warmTierIndices = indicesFilteredByTier(indices, "WARM");
  const hotTierIndices = indicesFilteredByTier(indices, "HOT");
  const hotTierList = hotTierIndices.length > 0 ? hotTierIndices : indicesFilteredByTier(indices, void 0);
  const hotTierSubheading = "Indices in this section are stored as active shards within the Search cluster, facilitating fast retrieval and search jobs. Data held in the Hot Tier has a permanent footprint in the Java Heap memory of the Search Cluster and in excess, will degrade search performance.";
  const warmTierSubheading = 'Indices in this section are stored as searchable snapshots within the Warm Tier Repository, facilitating cheap storage and low resource overheads. Retrieval and Search jobs of data held in the Warm Tier will be slower. Note that only Search nodes with the "Search" role can participate in Warm Tier search and retrieval.';
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    IndexSection,
    {
      headline: "Hot Tier",
      subheading: hotTierSubheading,
      indices: hotTierList,
      indexDetails,
      indexSetId
    }
  ), warmTierIndices.length > 0 && /* @__PURE__ */ React.createElement(
    IndexSection,
    {
      headline: "Warm Tier",
      subheading: warmTierSubheading,
      indices: warmTierIndices,
      indexDetails,
      indexSetId
    }
  ));
};
export default IndicesOverview;
